import styled from "styled-components";
import colors from "../../../assets/css/colors";

export const Row = styled.div`
    display: flex;

    @media (max-width: 500px){
        display: block;
    }
`;

export const THead = styled.thead`
    background: ${colors.grayLight} 0% 0% no-repeat padding-box;
    height: 34px;
    opacity: 1;
`;

export const Th = styled.th`
    font-family: muli, sans-serif;
    font-weight: 800;
    font-style: normal;
    color: ${colors.grayDark};
    text-align: center;
    letter-spacing: 0px;
    opacity: 1;
    text-transform: uppercase;
`;
